
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CRM_API_NEWSLEETER_SUBS_URL, CRM_API_TOKEN, NEWSLETTER_LIST } from '../../shared/constants'
import { timeout } from 'rxjs/operators'
import { NewsletterSubsForm } from './newsletter-subs-form'

@Component({
  selector: 'app-newsletter-subs-form',
  imports: [
    FormsModule,
    RouterModule
],
  templateUrl: './newsletter-subs-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './newsletter-subs-form.component.scss'
})
export class NewsletterSubsFormComponent {
  constructor(private http: HttpClient) { }

  @Input() showTitle: boolean = true

  form: NewsletterSubsForm = new NewsletterSubsForm()
  successMessage: string = ''
  token: string = CRM_API_TOKEN

  onSubmit() {
    const headers = new HttpHeaders({
      'Authorization': `Basic ${this.token}`,
      'Content-Type': 'application/json',
    })

    this.form.listName = NEWSLETTER_LIST

    if (this.form.email != null && this.form.email.trim() != '') {
      this.http.post(CRM_API_NEWSLEETER_SUBS_URL, this.form, { headers, observe: 'response' }).pipe(
        timeout(60000)
      ).subscribe({
        next: (response) => {
          console.log('Response:', response)
          this.successMessage = 'Thank you for subscribing!'
          this.form = new NewsletterSubsForm()
        },
        error: (error) => {
          if (error.name === 'TimeoutError') {
            console.error('Error: Request timed out')
            this.successMessage = 'Subscription timed out. Please try again later.'
          } else {
            console.error('Error:', error)
            this.successMessage = 'Operation failed because of an error. Please try again later.' + error
          }
        },
      })
    } else {
      this.successMessage = 'Please enter a valid email address'
    }
  }
}
